<template>
  <div class="g-sidenav-show" style="background-color: #f0f6ff;">
    <div class="min-height-300 bg-dark position-absolute w-100"></div>
    <HeaderMenu />
    <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
      <!-- Notificaciones -->
      <div class="position-fixed top-0 end-0 p-3" style="z-index: 1100">
        <div v-for="(notification, index) in notifications" :key="index"
          :class="['alert', notification.class, 'alert-dismissible fade show']" role="alert">
          {{ notification.message }}
          <button type="button" class="btn-close" @click="closeNotification(index)"></button>
        </div>
      </div>

      <div class="container-fluid py-4 pt-6" style="min-height: 100vh;">
        <!-- Spinner de carga inicial -->
        <div v-if="cargando" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>

        <div v-else class="row">
          <div class="col-12">
            <div class="card mb-4">
              <div class="card-header pb-0">
                <h5 class="mb-0">
                  <i class="fas fa-shield-alt me-2"></i>Configuración de Aprobación Avanzada
                </h5>
              </div>
              <div class="card-body">
                <!-- Configuración inicial -->
                <div v-if="!configuracionGuardada" class="row">
                  <div class="col-md-3">
                    <label class="form-label fw-bold">Esquema</label>
                    <select class="form-select" v-model="esquemaSeleccionadoId" @change="cargarConfiguracion">
                      <option value="">Selecciona un esquema</option>
                      <option v-for="esq in esquemasConAprobacionAvanzada" :key="esq.id" :value="esq.id">
                        {{ esq.nombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label fw-bold">Propiedad de Importe <small class="text-muted fw-normal">(opcional)</small></label>
                    <select class="form-select" v-model="config.propiedad_importe_id" :disabled="!esquemaSeleccionadoId">
                      <option :value="null">Sin importe (solo usuarios)</option>
                      <option v-for="prop in propiedadesNumericas" :key="prop.id" :value="prop.id">
                        {{ prop.nombre }}
                      </option>
                    </select>
                    <small class="text-muted">Propiedad numérica</small>
                  </div>
                  <div class="col-md-3">
                    <label class="form-label fw-bold">Propiedad Agrupadora</label>
                    <select class="form-select" v-model="config.propiedad_agrupadora_id" :disabled="!esquemaSeleccionadoId">
                      <option value="">Selecciona una propiedad</option>
                      <option v-for="prop in propiedadesLista" :key="prop.id" :value="prop.id">
                        {{ prop.nombre }}
                      </option>
                    </select>
                    <small class="text-muted">Propiedad tipo lista</small>
                  </div>
                  <div class="col-md-3 d-flex align-items-center ">
                    <button class="btn btn-primary btn-sm mb-0" @click="guardarConfiguracion" 
                      :disabled="!config.propiedad_agrupadora_id || guardando">
                      <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
                      <i v-else class="fas fa-save me-1"></i>Guardar
                    </button>
                  </div>

                  <!-- Vista previa de valores de lista (antes de guardar) -->
                  <div v-if="valoresLista.length > 0" class="mt-4">
                    <h6 class="mb-3"><i class="fas fa-list me-2"></i>Valores disponibles para reglas</h6>
                    <div class="d-flex flex-wrap gap-2">
                      <span v-for="valor in valoresLista" :key="valor.id" class="badge bg-secondary">
                        {{ valor.descripcion }}
                      </span>
                    </div>
                    <small class="text-muted d-block mt-2">
                      <i class="fas fa-info-circle me-1"></i>Guarda la configuración para definir reglas por cada valor
                    </small>
                  </div>
                </div>

                <!-- Reglas por valor de lista (cuando ya hay configuración) -->
                <div v-else>
                    <!-- Info de configuración actual -->
                    <div class="d-flex justify-content-between align-items-center mb-4">
                      <p class="mb-0">
                        Esquema <strong>{{ esquemaSeleccionado?.nombre }}</strong>: 
                        <template v-if="config.propiedad_importe">
                          Basado en <strong>{{ config.propiedad_importe?.nombre }}</strong> 
                        </template>
                        <template v-else>
                          <span class="text-muted">(sin importe)</span>
                        </template>
                        agrupado por <strong>{{ config.propiedad_agrupadora?.nombre }}</strong>
                      </p>
                      <button class="btn btn-sm btn-outline-danger" @click="eliminarConfiguracion">
                        <i class="fas fa-trash me-1"></i>Eliminar configuración
                      </button>
                    </div>

                    <!-- Lista de valores para configurar -->
                    <h6 class="mb-3"><i class="fas fa-list me-2"></i>Reglas por {{ config.propiedad_agrupadora?.nombre }}</h6>
                    
                    <div class="accordion" id="accordionReglas">
                      <div v-for="(valor, index) in valoresLista" :key="valor.id" class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button d-flex align-items-center" :class="{ collapsed: !valor.expanded }" type="button" @click="toggleValor(index)">
                            <span class="me-5 badge-estado" style="width: 100px; display: inline-block;">
                              <span v-if="valor.regla" class="badge bg-success">Configurado</span>
                              <span v-else class="badge bg-secondary">Sin configurar</span>
                            </span>
                            <span>{{ valor.descripcion }}</span>
                          </button>
                        </h2>
                        <div class="accordion-collapse collapse" :class="{ show: valor.expanded }">
                          <div class="accordion-body">
                            <!-- Formulario de regla -->
                            <div class="row">
                              <!-- Tipo 1 y 2 solo si hay propiedad de importe -->
                              <template v-if="config.propiedad_importe">
                                <div class="col-md-4">
                                  <label class="form-label fw-bold">Aprobación automática por importe</label>
                                  <div class="input-group">
                                    <span class="input-group-text">≤</span>
                                    <input type="number" class="form-control" v-model="valor.reglaEdit.tipo1_importe_max" 
                                      placeholder="Ej: 50" step="0.01">
                                    <span class="input-group-text">€</span>
                                  </div>
                                  <small class="text-muted">Hasta este importe se aprueban automáticamente</small>
                                  <label class="form-label fw-bold mt-2">Usuario aprobador si excede el importe:</label>
                                  <select class="form-select form-select-sm" v-model="valor.reglaEdit.tipo1_user_id">
                                    <option :value="null">Sin usuario</option>
                                    <option v-for="user in usuarios" :key="user.id" :value="user.id">
                                      {{ user.name }}
                                    </option>
                                  </select>
                                </div>
                                <div class="col-md-4">
                                  <label class="form-label fw-bold">Aprobación por acumulado</label>
                                  <div class="row g-2">
                                    <div class="col-7">
                                      <div class="input-group">
                                        <span class="input-group-text">≤</span>
                                        <input type="number" class="form-control" v-model="valor.reglaEdit.tipo2_importe_max" 
                                          placeholder="Ej: 5000" step="0.01">
                                        <span class="input-group-text">€</span>
                                      </div>
                                    </div>
                                    <div class="col-5">
                                      <select class="form-select" v-model="valor.reglaEdit.tipo2_periodo">
                                        <option value="">Sin período</option>
                                        <option value="mensual">Mensual</option>
                                        <option value="trimestral">Trimestral</option>
                                        <option value="anual">Anual</option>
                                      </select>
                                    </div>
                                  </div>
                                  <small class="text-muted">Límite acumulado permitido por período</small>
                                  <label class="form-label fw-bold mt-2">Usuario aprobador si excede el importe:</label>
                                  <select class="form-select form-select-sm" v-model="valor.reglaEdit.tipo2_user_id">
                                    <option :value="null">Sin usuario</option>
                                    <option v-for="user in usuarios" :key="user.id" :value="user.id">
                                      {{ user.name }}
                                    </option>
                                  </select>
                                </div>
                                <div class="col-md-4">
                                  <label class="form-label fw-bold">Rangos de aprobación</label>
                                  <table class="table table-sm table-bordered mb-2">
                                    <thead class="table-light">
                                      <tr>
                                        <th>Desde (€)</th>
                                        <th>Usuario</th>
                                        <th style="width: 30px"></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(rango, ri) in valor.reglaEdit.rangos" :key="ri">
                                        <td>
                                          <input type="number" class="form-control form-control-sm" 
                                            v-model="rango.importe_desde" placeholder="0" step="0.01">
                                        </td>
                                        <td>
                                          <select class="form-select form-select-sm" v-model="rango.user_id">
                                            <option value="">Usuario</option>
                                            <option v-for="user in usuarios" :key="user.id" :value="user.id">
                                              {{ user.name }}
                                            </option>
                                          </select>
                                        </td>
                                        <td class="text-center p-1">
                                          <button class="btn btn-sm btn-outline-danger p-1" @click="eliminarRango(valor, ri)">
                                            <i class="fas fa-times"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <button class="btn btn-sm btn-outline-primary" @click="agregarRango(valor)">
                                    <i class="fas fa-plus me-1"></i>Añadir rango
                                  </button>
                                  <div class="form-check mt-2">
                                    <input class="form-check-input" type="checkbox" v-model="valor.reglaEdit.aprobacion_acumulada" :id="'acumulada_' + valor.id">
                                    <label class="form-check-label" :for="'acumulada_' + valor.id">
                                      <small>Aprobación acumulada (todos los rangos deben aprobar)</small>
                                    </label>
                                  </div>
                                </div>
                              </template>

                              <!-- Sin importe: solo aprobadores -->
                              <template v-else>
                                <div class="col-md-6">
                                  <label class="form-label fw-bold">Aprobadores</label>
                                  <table class="table table-sm table-bordered mb-2">
                                    <thead class="table-light">
                                      <tr>
                                        <th style="width: 60px">Orden</th>
                                        <th>Usuario</th>
                                        <th style="width: 30px"></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(rango, ri) in valor.reglaEdit.rangos" :key="ri">
                                        <td class="text-center">{{ ri + 1 }}</td>
                                        <td>
                                          <select class="form-select form-select-sm" v-model="rango.user_id">
                                            <option value="">Selecciona usuario</option>
                                            <option v-for="user in usuarios" :key="user.id" :value="user.id">
                                              {{ user.name }}
                                            </option>
                                          </select>
                                        </td>
                                        <td class="text-center p-1">
                                          <button class="btn btn-sm btn-outline-danger p-1" @click="eliminarRango(valor, ri)">
                                            <i class="fas fa-times"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <button class="btn btn-sm btn-outline-primary" @click="agregarRangoSinImporte(valor)">
                                    <i class="fas fa-plus me-1"></i>Añadir aprobador
                                  </button>
                                </div>
                                <div class="col-md-6">
                                  <label class="form-label fw-bold">Modo de aprobación</label>
                                  <div class="form-check">
                                    <input class="form-check-input" type="radio" :name="'modo_' + valor.id" :id="'cualquiera_' + valor.id" 
                                      :checked="!valor.reglaEdit.aprobacion_acumulada" @change="valor.reglaEdit.aprobacion_acumulada = false">
                                    <label class="form-check-label" :for="'cualquiera_' + valor.id">
                                      Cualquiera puede aprobar <small class="text-muted">(el primero que lo haga)</small>
                                    </label>
                                  </div>
                                  <div class="form-check">
                                    <input class="form-check-input" type="radio" :name="'modo_' + valor.id" :id="'todos_' + valor.id"
                                      :checked="valor.reglaEdit.aprobacion_acumulada" @change="valor.reglaEdit.aprobacion_acumulada = true">
                                    <label class="form-check-label" :for="'todos_' + valor.id">
                                      Todos deben aprobar <small class="text-muted">(en el orden definido)</small>
                                    </label>
                                  </div>
                                </div>
                              </template>
                            </div>

                            <!-- Botones de acción -->
                            <div class="mt-4 pt-3 border-top">
                              <button class="btn btn-primary me-2" @click="guardarRegla(valor)" :disabled="guardandoRegla">
                                <span v-if="guardandoRegla" class="spinner-border spinner-border-sm me-2"></span>
                                <i v-else class="fas fa-save me-2"></i>Guardar regla
                              </button>
                              <button v-if="valor.regla" class="btn btn-outline-danger" @click="eliminarRegla(valor)">
                                <i class="fas fa-trash me-1"></i>Eliminar regla
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="valoresLista.length === 0" class="text-center py-4 text-muted">
                      <i class="fas fa-info-circle me-2"></i>No hay valores en la lista seleccionada
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import HeaderMenu from '@/components/HeaderMenu.vue';
import { ref, computed, onMounted, watch } from 'vue';
import { useRoute } from 'vue-router';
import axiosInstance from '@/axios';

export default {
  name: 'AprobacionAvanzadaView',
  components: { HeaderMenu },
  setup() {
    const route = useRoute();
    const notifications = ref([]);
    const esquemas = ref([]);
    const esquemaSeleccionadoId = ref('');
    const esquemaSeleccionado = ref(null);
    const usuarios = ref([]);
    const config = ref({
      propiedad_importe_id: '',
      propiedad_agrupadora_id: '',
      aprobacion_acumulada: false,
      propiedad_importe: null,
      propiedad_agrupadora: null
    });
    const valoresLista = ref([]);
    const guardando = ref(false);
    const guardandoRegla = ref(false);
    const configuracionGuardada = ref(false);
    const cargando = ref(false);

    const closeNotification = (index) => notifications.value.splice(index, 1);
    const showNotification = (message, type = 'alert-info') => {
      notifications.value.push({ message, class: type });
      setTimeout(() => notifications.value.shift(), 5000);
    };

    const esquemasConAprobacionAvanzada = computed(() => {
      return esquemas.value.filter(e => e.aprobacion_avanzada);
    });

    const propiedadesNumericas = computed(() => {
      if (!esquemaSeleccionado.value?.propiedades) return [];
      return esquemaSeleccionado.value.propiedades.filter(p => 
        p.tipo === 'int' || p.tipo === 'decimal' || p.tipo === 'decimal2' || p.tipo === 'decimal4'
      );
    });

    const propiedadesLista = computed(() => {
      if (!esquemaSeleccionado.value) return [];
      return esquemaSeleccionado.value.propiedades.filter(p => p.tipo === 'list');
    });

    const cargarEsquemas = async () => {
      try {
        const response = await axiosInstance.get('/api/esquemas');
        esquemas.value = response.data.esquemas || response.data;
        esquemas.value.forEach(e => {
          e.aprobacion_avanzada = !!e.aprobacion_avanzada;
        });
      } catch (error) {
        console.error('Error cargando esquemas:', error);
        showNotification('Error al cargar esquemas', 'alert-danger');
      }
    };

    const cargarUsuarios = async () => {
      try {
        const response = await axiosInstance.get('/api/usuarios');
        usuarios.value = response.data.users || response.data;
      } catch (error) {
        console.error('Error cargando usuarios:', error);
      }
    };

    const cargarConfiguracion = async () => {
      if (!esquemaSeleccionadoId.value) {
        esquemaSeleccionado.value = null;
        configuracionGuardada.value = false;
        return;
      }

      cargando.value = true;
      
      // Usar esquema de la lista ya cargada (incluye propiedades)
      esquemaSeleccionado.value = esquemas.value.find(e => e.id == esquemaSeleccionadoId.value);
      
      try {
        const response = await axiosInstance.get(`/api/aprobacionAvanzada/config/${esquemaSeleccionadoId.value}`);
        const cfg = response.data.config ?? response.data.data?.config;
        if (cfg) {
          config.value = {
            propiedad_importe_id: cfg.propiedad_importe_id,
            propiedad_agrupadora_id: cfg.propiedad_agrupadora_id,
            aprobacion_acumulada: !!cfg.aprobacion_acumulada,
            propiedad_importe: cfg.propiedad_importe,
            propiedad_agrupadora: cfg.propiedad_agrupadora
          };
          configuracionGuardada.value = true;
          await cargarValoresLista(cfg.reglas || []);
        } else {
          resetConfig();
        }
      } catch (error) {
        console.error('Error cargando configuración:', error);
        resetConfig();
      } finally {
        cargando.value = false;
      }
    };

    const resetConfig = () => {
      config.value = {
        propiedad_importe_id: '',
        propiedad_agrupadora_id: '',
        aprobacion_acumulada: false,
        propiedad_importe: null,
        propiedad_agrupadora: null
      };
      configuracionGuardada.value = false;
      valoresLista.value = [];
    };

    const cargarValoresLista = async (reglasExistentes) => {
      if (!config.value.propiedad_agrupadora_id) return;
      const propLista = esquemaSeleccionado.value?.propiedades?.find(
        p => p.id == config.value.propiedad_agrupadora_id
      );
      const listaId = propLista?.lista_id ?? config.value.propiedad_agrupadora?.lista_id;
      if (!listaId) return;

      try {
        const response = await axiosInstance.get(`/api/listas/${listaId}/valores`);
        const data = response.data?.data ?? response.data;
        const valores = data?.lista?.valores ?? data?.valores ?? response.data?.lista?.valores ?? response.data?.valores ?? [];
        const valorId = (v) => v.id ?? v.lista_valor_id;
        const reglaParaValor = (vid) => reglasExistentes.find(r => r.lista_valor_id == vid || Number(r.lista_valor_id) === Number(vid));
        const buildReglaEdit = (regla) => regla ? {
          tipo1_importe_max: regla.tipo1_importe_max,
          tipo1_user_id: regla.tipo1_user_id || null,
          tipo2_importe_max: regla.tipo2_importe_max,
          tipo2_periodo: regla.tipo2_periodo || '',
          tipo2_user_id: regla.tipo2_user_id || null,
          aprobacion_acumulada: !!regla.aprobacion_acumulada,
          rangos: (regla.rangos || []).map(r => ({ importe_desde: r.importe_desde, user_id: r.user_id }))
        } : {
          tipo1_importe_max: null, tipo1_user_id: null, tipo2_importe_max: null, tipo2_periodo: '', tipo2_user_id: null, aprobacion_acumulada: false, rangos: []
        };
        valoresLista.value = valores.map(v => {
          const vid = valorId(v);
          const reglaExistente = reglaParaValor(vid);
          return {
            id: vid,
            descripcion: v.descripcion ?? v.valor ?? '',
            expanded: false,
            regla: reglaExistente || null,
            reglaEdit: buildReglaEdit(reglaExistente)
          };
        });
      } catch (error) {
        console.error('Error cargando valores de lista:', error);
      }
    };

    const guardarConfiguracion = async () => {
      guardando.value = true;
      try {
        await axiosInstance.post(`/api/aprobacionAvanzada/config/${esquemaSeleccionadoId.value}`, {
          propiedad_importe_id: config.value.propiedad_importe_id,
          propiedad_agrupadora_id: config.value.propiedad_agrupadora_id
        });
        showNotification('Configuración guardada correctamente', 'alert-success');
        await cargarConfiguracion();
      } catch (error) {
        console.error('Error guardando configuración:', error);
        showNotification('Error al guardar configuración', 'alert-danger');
      } finally {
        guardando.value = false;
      }
    };

    const eliminarConfiguracion = async () => {
      if (!confirm('¿Estás seguro de eliminar toda la configuración de aprobación avanzada?')) return;
      
      try {
        await axiosInstance.delete(`/api/aprobacionAvanzada/config/${esquemaSeleccionadoId.value}`);
        showNotification('Configuración eliminada', 'alert-success');
        resetConfig();
      } catch (error) {
        console.error('Error eliminando configuración:', error);
        showNotification('Error al eliminar configuración', 'alert-danger');
      }
    };

    const toggleValor = (index) => {
      valoresLista.value[index].expanded = !valoresLista.value[index].expanded;
    };

    const agregarRango = (valor) => {
      valor.reglaEdit.rangos.push({ importe_desde: 0, user_id: '' });
    };

    const agregarRangoSinImporte = (valor) => {
      valor.reglaEdit.rangos.push({ importe_desde: 0, user_id: '' });
    };

    const eliminarRango = (valor, index) => {
      valor.reglaEdit.rangos.splice(index, 1);
    };

    const guardarRegla = async (valor) => {
      guardandoRegla.value = true;
      try {
        const response = await axiosInstance.post(`/api/aprobacionAvanzada/regla/${esquemaSeleccionadoId.value}`, {
          lista_valor_id: valor.id,
          tipo1_importe_max: valor.reglaEdit.tipo1_importe_max || null,
          tipo1_user_id: valor.reglaEdit.tipo1_user_id || null,
          tipo2_importe_max: valor.reglaEdit.tipo2_importe_max || null,
          tipo2_periodo: valor.reglaEdit.tipo2_periodo || null,
          tipo2_user_id: valor.reglaEdit.tipo2_user_id || null,
          aprobacion_acumulada: valor.reglaEdit.aprobacion_acumulada || false,
          rangos: valor.reglaEdit.rangos.filter(r => r.user_id)
        });
        
        const reglaGuardada = response.data?.regla || response.data;
        let nuevaRegla;
        let nuevoReglaEdit;
        if (reglaGuardada && reglaGuardada.id) {
          nuevaRegla = reglaGuardada;
          nuevoReglaEdit = {
            tipo1_importe_max: reglaGuardada.tipo1_importe_max,
            tipo1_user_id: reglaGuardada.tipo1_user_id || null,
            tipo2_importe_max: reglaGuardada.tipo2_importe_max,
            tipo2_periodo: reglaGuardada.tipo2_periodo || '',
            tipo2_user_id: reglaGuardada.tipo2_user_id || null,
            aprobacion_acumulada: !!reglaGuardada.aprobacion_acumulada,
            rangos: (reglaGuardada.rangos || []).map(r => ({
              importe_desde: r.importe_desde,
              user_id: r.user_id
            }))
          };
        } else {
          nuevaRegla = {
            id: response.data?.id || response.data?.regla_id || Date.now(),
            lista_valor_id: valor.id,
            tipo1_importe_max: valor.reglaEdit.tipo1_importe_max,
            tipo1_user_id: valor.reglaEdit.tipo1_user_id,
            tipo2_importe_max: valor.reglaEdit.tipo2_importe_max,
            tipo2_periodo: valor.reglaEdit.tipo2_periodo,
            tipo2_user_id: valor.reglaEdit.tipo2_user_id,
            aprobacion_acumulada: valor.reglaEdit.aprobacion_acumulada,
            rangos: valor.reglaEdit.rangos.filter(r => r.user_id).map((r, idx) => ({
              id: idx + 1,
              importe_desde: r.importe_desde,
              user_id: r.user_id,
              orden: idx + 1
            }))
          };
          nuevoReglaEdit = {
            tipo1_importe_max: valor.reglaEdit.tipo1_importe_max,
            tipo1_user_id: valor.reglaEdit.tipo1_user_id || null,
            tipo2_importe_max: valor.reglaEdit.tipo2_importe_max,
            tipo2_periodo: valor.reglaEdit.tipo2_periodo || '',
            tipo2_user_id: valor.reglaEdit.tipo2_user_id || null,
            aprobacion_acumulada: !!valor.reglaEdit.aprobacion_acumulada,
            rangos: valor.reglaEdit.rangos.filter(r => r.user_id).map(r => ({
              importe_desde: r.importe_desde,
              user_id: r.user_id
            }))
          };
        }
        const idx = valoresLista.value.findIndex(v => v.id === valor.id);
        if (idx !== -1) {
          valoresLista.value[idx] = {
            ...valoresLista.value[idx],
            regla: nuevaRegla,
            reglaEdit: nuevoReglaEdit
          };
        }
        showNotification('Regla guardada correctamente', 'alert-success');
      } catch (error) {
        console.error('Error guardando regla:', error);
        showNotification('Error al guardar regla', 'alert-danger');
      } finally {
        guardandoRegla.value = false;
      }
    };

    const eliminarRegla = async (valor) => {
      if (!valor.regla || !confirm('¿Eliminar esta regla?')) return;
      try {
        await axiosInstance.delete(`/api/aprobacionAvanzada/regla/${valor.regla.id}`);
        const idx = valoresLista.value.findIndex(v => v.id === valor.id);
        if (idx !== -1) {
          valoresLista.value[idx] = {
            ...valoresLista.value[idx],
            regla: null,
            reglaEdit: {
              tipo1_importe_max: null,
              tipo1_user_id: null,
              tipo2_importe_max: null,
              tipo2_periodo: '',
              tipo2_user_id: null,
              aprobacion_acumulada: false,
              rangos: []
            }
          };
        }
        showNotification('Regla eliminada', 'alert-success');
      } catch (error) {
        console.error('Error eliminando regla:', error);
        showNotification('Error al eliminar regla', 'alert-danger');
      }
    };

    onMounted(async () => {
      await cargarEsquemas();
      await cargarUsuarios();
      
      // Si viene con esquema en query params
      if (route.query.esquema) {
        esquemaSeleccionadoId.value = route.query.esquema;
        await cargarConfiguracion();
      }
    });

    watch(() => route.query.esquema, async (newVal) => {
      if (newVal) {
        esquemaSeleccionadoId.value = newVal;
        await cargarConfiguracion();
      }
    });

    // Cargar valores de lista cuando se selecciona propiedad agrupadora
    watch(() => config.value.propiedad_agrupadora_id, async (newVal) => {
      if (newVal && !configuracionGuardada.value) {
        await cargarValoresLista([]);
      }
    });

    return {
      notifications,
      closeNotification,
      esquemas,
      esquemasConAprobacionAvanzada,
      esquemaSeleccionadoId,
      esquemaSeleccionado,
      usuarios,
      config,
      valoresLista,
      guardando,
      guardandoRegla,
      configuracionGuardada,
      cargando,
      propiedadesNumericas,
      propiedadesLista,
      cargarConfiguracion,
      guardarConfiguracion,
      eliminarConfiguracion,
      toggleValor,
      agregarRango,
      agregarRangoSinImporte,
      eliminarRango,
      guardarRegla,
      eliminarRegla
    };
  }
};
</script>

<style scoped>
.accordion-button:not(.collapsed) {
  background-color: #e7f3ff;
  color: #0d6efd;
}

.accordion-button.collapsed {
  border: 1px solid #dee2e6;
}

.accordion-button::after {
  margin-left: auto;
  position: absolute;
  right: 1rem;
}

.badge {
  font-weight: 500;
}

.accordion-body {
  border: 1px solid #dee2e6;
  border-top: none;
}
</style>

